<template>
	<div class="page-wrapper">
		<loading-screen :show="displayLoadingScreen" :appBackground="true" :autoStop="true" @stopLoadingScreen="displayLoadingScreen = false"></loading-screen>
		<!-- BEGIN HEADER -->
		<div class="page-header navbar navbar-fixed-top">
			<!-- BEGIN HEADER INNER -->
			<div class="page-header-inner">
				<div class="page-logo">
					<a>
						<img src="../assets/img/app/logo.png" alt="logo" class="logo-default logo-unoapp" />
					</a>
					<div @click="toggleSidebarCollapse()" class="menu-toggler sidebar-toggler">
						<span></span>
					</div>
				</div>
				<!-- END LOGO -->
				<!-- BEGIN RESPONSIVE MENU TOGGLER -->
				<a class="menu-toggler responsive-toggler">
					<span></span>
				</a>
				<!-- END RESPONSIVE MENU TOGGLER -->
				<!-- BEGIN TOP NAVIGATION MENU -->
				<div class="top-menu" v-if="!waitingForData">
					<ul class="nav navbar-nav pull-right"><!-- BEGIN USER LOGIN DROPDOWN -->
						<dropdown :isLi="true" :passedClass="'dropdown-user'">
							<a href="javascript:;" slot="button" class="dropdown-toggle" data-toggle="dropdown" data-hover="dropdown" data-close-others="true">
								<span class="username username-hide-on-mobile">{{ activeUser.name.first_name && activeUser.name.last_name ? `${activeUser.name.first_name} ${activeUser.name.last_name}` : 'User' }}</span>
								<i class="fa fa-angle-down"></i>
							</a>
						  	<ul slot="dropdown-menu" class="dropdown-menu">
						  		<li v-if="userAccountsLength > 1">
									<a @click="changeAccount()">
										<i class="icon-users"></i> Change Account
									</a>
								</li>
								<li>
									<a @click="logOut()">
										<i class="icon-logout"></i> Log Out
									</a>
								</li>
						  	</ul>
						</dropdown>

						<!-- END USER LOGIN DROPDOWN -->
						<!-- BEGIN QUICK SIDEBAR TOGGLER -->
						<li class="dropdown dropdown-quick-sidebar-toggler width-auto" @click="toggleQuickSidebar($event)">
							<a class="dropdown-toggle location-panel width-auto">
								<div class="logo-container">
									<img class="business-logo" src="../../metronic_src/theme/assets/global/img/portfolio/600x600/01.jpg" width="38" height="38">
								</div>
								<div class="location-name-container" v-if="activeLocationId">
									<span class="business-name">{{ activeBusinessName }}</span>
									<span class="business-location-name">{{ activeLocationName }}</span>
								</div>
								<div class="location-name-container" v-else>
									<span class="business-name big">{{ activeBusinessName }}</span>
								</div>
							</a>
						</li>
						<!-- END QUICK SIDEBAR TOGGLER -->
					</ul>
				</div>
				<!-- END TOP NAVIGATION MENU -->
			</div>
			<!-- END HEADER INNER -->
		</div>
		<!-- END HEADER -->
		<!-- BEGIN HEADER & CONTENT DIVIDER -->
		<div class="clearfix"> </div>
		<!-- END HEADER & CONTENT DIVIDER -->
		<!-- BEGIN CONTAINER -->
		<div class="page-container" v-if="!waitingForData">
			<!-- BEGIN SIDEBAR -->
			<div class="page-sidebar-wrapper">
				<!-- NOTE: Set data-auto-scroll="false" to disable the sidebar from auto scrolling/focusing -->
				<!-- NOTE: Change data-auto-speed="200" to adjust the sub menu slide up/down speed -->
				<div class="page-sidebar navbar-collapse collapse">
					<!-- NOTE: Set data-auto-scroll="false" to disable the sidebar from auto scrolling/focusing -->
					<!-- NOTE: Set data-keep-expand="true" to keep the submenues expanded -->
					<!-- NOTE: Set data-auto-speed="200" to adjust the sub menu slide up/down speed -->
					<ul class="page-sidebar-menu page-header-fixed" data-keep-expand="false">
						<li class="nav-item start" :class="{'active': currentRoute === 'dashboard'}">
							<router-link to="/app/dashboard" class="nav-link nav-toggle">
								<i class="fa fa-dashboard"></i>
								<span class="title">Dashboard</span>
								<span class="selected"></span>
							</router-link>
						</li>
						<li v-if="activeBusinessId && activeBusinessId !== 1 && !activeLocationId" class="nav-item" :class="{'active': currentRoute === 'my_business'}" id="my_business_link">
							<a class="nav-link nav-toggle unselectable" @click="toggleNavigation($event)">
								<i class="fa fa-briefcase"></i>
								<span class="title">My Business</span>
								<span class="arrow"></span>
							</a>
							<ul class="sub-menu">
								<li class="nav-item" :class="{'active': currentRoute === 'my_business' && currentSubRoute === 'users'}" id="my_business_users_link">
									<router-link to="/app/my_business/users" class="nav-link">
										<i class="fa fa-group"></i>
										<span class="title">Users</span>
									</router-link>
								</li>
								<li class="nav-item" :class="{'active': currentRoute === 'my_business' && currentSubRoute === 'roles'}" id="my_business_roles_link">
									<router-link to="/app/my_business/roles" class="nav-link">
										<i class="fa fa-user"></i>
										<span class="title">Roles</span>
									</router-link>
								</li>
								<li class="nav-item" :class="{'active': currentRoute === 'my_business' && currentSubRoute === 'regions'}" id="my_business_regions_link">
									<router-link to="/app/my_business/regions" class="nav-link">
										<i class="fa fa-globe"></i>
										<span class="title">Regions</span>
									</router-link>
								</li>
								<li class="nav-item" :class="{'active': currentRoute === 'my_business' && currentSubRoute === 'locations'}" id="my_business_locations_link">
									<router-link to="/app/my_business/locations" class="nav-link">
										<i class="fa fa-map-marker"></i>
										<span class="title">Locations</span>
									</router-link>
								</li>
							</ul>
						</li>
						<li v-if="activeBusinessId && activeLocationId" class="nav-item" :class="{'active': currentRoute === 'my_location'}" id="my_location_link">
							<a class="nav-link nav-toggle unselectable" @click="toggleNavigation($event)">
								<i class="fa fa-map-marker"></i>
								<span class="title">My Location</span>
								<span class="arrow"></span>
							</a>
							<ul class="sub-menu">
								<li class="nav-item" :class="{'active': currentRoute === 'my_location' && currentSubRoute === 'users'}" id="my_location_users_link">
									<router-link to="/app/my_location/users" class="nav-link">
										<i class="fa fa-group"></i>
										<span class="title">Users</span>
									</router-link>
								</li>
								<li class="nav-item" :class="{'active': currentRoute === 'my_location' && currentSubRoute === 'roles'}" id="my_location_roles_link">
									<router-link to="/app/my_location/roles" class="nav-link">
										<i class="fa fa-user"></i>
										<span class="title">Roles</span>
									</router-link>
								</li>
							</ul>
						</li>
						<li v-for="app in accessibleApps" class="nav-item" :id="app.app_id" :class="{'active': currentRoute === app.route}">
							<router-link v-if="app.id !== 12" :to="`/app/${app.route}`" class="nav-link">
								<i class="fa" :class="app.fa"></i>
								<span class="title">{{ app.title }}</span>
							</router-link>
							<a v-if="app.id === 12" :href="`https://ecomm.staging.unoapp.io/#/login/${activeBusinessId}/${v3Token}`" target="_blank">
								<i class="fa" :class="app.fa"></i>
								<span class="title">{{ app.title }}</span>
							</a>
						</li>
						<li v-if="unoappAccount && activeBusinessId && activeLocationId" class="nav-item" :class="{'active': currentRoute === 'unoapp_signage'}" id="unoapp_signage_link">
              <a class="nav-link nav-toggle unselectable" @click="toggleNavigation($event)">
                <i class="fa fa-refresh"></i>
                <span class="title">Signage</span>
                <span class="arrow"></span>
              </a>
              <ul class="sub-menu">
                <li class="nav-item" :class="{'active': currentRoute === 'unoapp_signage' && currentSubRoute === 'layout'}" id="unoapp_signage_layout_link">
                  <router-link to="/app/unoapp_signage/layout" class="nav-link">
                    <i class="fa fa-group"></i>
                    <span class="title">Layouts</span>
                  </router-link>
                </li>
                <li class="nav-item" :class="{'active': currentRoute === 'unoapp_signage' && currentSubRoute === 'playlist'}" id="unoapp_signage_playlist_link">
                  <router-link to="/app/unoapp_signage/playlist" class="nav-link">
                    <i class="fa fa-group"></i>
                    <span class="title">Presentations/Playlists</span>
                  </router-link>
                </li>
				 				<li class="nav-item" :class="{'active': currentRoute === 'unoapp_signage' && currentSubRoute === 'content'}" id="unoapp_signage_content_link">
                  <router-link to="/app/unoapp_signage/content" class="nav-link">
                    <i class="fa fa-group"></i>
                    <span class="title">Schedules</span>
                  </router-link>
                </li>
              </ul>
            </li>
						<li class="heading" v-if="unoappAccount">
							<h3 class="uppercase">UNOapp Admin Tools</h3>
						</li>
						<li v-if="unoappAccount" class="nav-item" :class="{'active': currentRoute === 'unoapp_business'}" id="unoapp_business_link">
							<a class="nav-link nav-toggle unselectable" @click="toggleNavigation($event)">
								<i class="fa fa-refresh"></i>
								<span class="title">UNOapp Business</span>
								<span class="arrow"></span>
							</a>
							<ul class="sub-menu">
								<li class="nav-item" :class="{'active': currentRoute === 'unoapp_business' && currentSubRoute === 'users'}" id="unoapp_business_users_link">
									<router-link to="/app/unoapp_business/users" class="nav-link">
										<i class="fa fa-group"></i>
										<span class="title">Users</span>
									</router-link>
								</li>
								<li class="nav-item" :class="{'active': currentRoute === 'unoapp_business' && currentSubRoute === 'roles'}" id="unoapp_business_roles_link">
									<router-link to="/app/unoapp_business/roles" class="nav-link">
										<i class="fa fa-user"></i>
										<span class="title">Roles</span>
									</router-link>
								</li>
							</ul>
						</li>
						<li v-if="unoappAccount" class="nav-item" :class="{'active': currentRoute === 'business_manager'}" id="business_manager_link">
							<router-link to="/app/business_manager" class="nav-link">
								<i class="fa fa-briefcase"></i>
								<span class="title">Business Manager</span>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
			<!-- END SIDEBAR -->
			<!-- BEGIN CONTENT -->
			<div class="page-content-wrapper">
				<!-- BEGIN CONTENT BODY -->
				<div class="page-content">
					<router-view></router-view>
				</div>
			</div>
			<!-- BEGIN QUICK SIDEBAR -->
			<div class="page-quick-sidebar-wrapper" data-close-on-body-click="false">
				<a class="page-quick-sidebar-toggler" @click="toggleQuickSidebar($event)">
					<span class="icon-close"></span>
				</a>
				<app-side-panel @updateActiveBusiness="setActiveBusiness"></app-side-panel>
			</div>
			<!-- END QUICK SIDEBAR -->
		</div>
		<modal :show.sync="displayImStillHere" effect="fade">
			<div slot="modal-header" class="modal-header">
				<h4 class="modal-title">Are you still there?</h4>
			</div>
			<div slot="modal-body" class="modal-body">
				You've been away from the computer for a while. Let us know if you are still here or you will be logged out.
			</div>
			<div slot="modal-footer" class="modal-footer">
				<button type="button" class="btn btn-primary" @click="imStillHere()">I'm still here</button>
			</div>
		</modal>
	</div>
</template>

<script>
import $ from 'jquery'
import Auth from '../controllers/Auth'
import Account from '../controllers/Account'
import User from '../controllers/User'
import Modal from './modules/Modal'
import Dropdown from './modules/Dropdown'
import LoadingScreen from './modules/LoadingScreen'
import AppSidePanel from './AppSidePanel'
import { throttle, debounce } from 'lodash'
import GlobalFunctions from '../global'
import { mapActions, mapGetters } from 'vuex'

/**
 * App module is the main component which holds the navigation, page header, and side panel.
 * @class App
 * @since 0.0.2
 */

/**
 * Create a variable that will hold the timeout for logging the user out.
 * @memberof App
 */
let localTimeout
/**
 * Create a variable that will hold the interval for checking the localStorage.
 * @memberof App
 */
let globalInterval

/**
 * Set the timer for session length.
 * @var {integer}
 * @example Hours * Minutes * Seconds * 1000
 * @memberof App
 */
const timer = 3 * 60 * 60 * 1000

/**
 * Set the interval time for when to check localStorage.
 * @var {integer}
 * @example Minutes * Seconds * 1000
 * @memberof App
 */
const intervalCount = 5 * 60 * 1000

/**
 * Set the timeout count for length of `I'm still here` modal.
 * @var {integer}
 * @example Minutes * Seconds * 1000
 * @memberof App
 */
const timeoutCount = 3 * 60 * 1000

/**
 * Set the throttle timer for how often to register click events for session activity.
 * @var {integer}
 * @example Minutes * Seconds * 1000
 * @memberof App
 */
const throttleEventTimer = 3 * 60 * 1000

export default {
	data () {
		return {
			currentRoute: '',
			currentSubRoute: '',
			routeMessage: '',
			displayImStillHere: false,
			displayLoadingScreen: false,
			activeUser: {
				name: {},
				email: ''
			},
			waitingForData: true,
			activeTab: 0,
			locationSearch: {
				search: ''
			},
			businessSearch: {
				search: ''
			},
			locations: [],
			locationSearchResults: [],
			businessSearchResults: [],
			locationSearchError: '',
			businessSearchError: '',
			localBusinessId: 0
		}
	},
	/**
	 * Run on `created` to check whether or not the user is supposed to be logged in.
	 * @function
	 * @returns {undefined}
	 * @memberof App
	 * @version 0.0.4
	 */
	created () {
		let _this = this

		const now = new Date().getTime()
		// eslint-disable-next-line
		const sessionStart = localStorage.getItem('sessionStart')
		if (sessionStart != null) {
			if (now - sessionStart < timer + timeoutCount + 2000) {
				// If the length of the session is less than the session time maximum + the modal timeout count + a 2 second buffer.
				Auth.refresh().then(response => {
					_this.setV3Token(response.payload.token)

					_this.getCurrentUserDetails()

					_this.setCurrentRoute()
					// eslint-disable-next-line
					localStorage.removeItem('sessionStart')
					_this.checkLocalStorage()

					if (globalInterval) {
						clearInterval(globalInterval)
					}
					globalInterval = setInterval(() => { _this.checkLocalStorage() }, intervalCount)
				}).catch(_this.$root.errorWrapper(e => {
					// Address other error cases
				}))
			} else {
				this.displayLoadingScreen = false
				this.logOut()
			}
		} else {
			// If the sessionStart doesn't exist yet then we need to store it in localStorage and set up the global check.
			this.displayLoadingScreen = false
			this.setCurrentRoute()
			this.checkLocalStorage()

			if (globalInterval) {
				clearInterval(globalInterval)
			}
			globalInterval = setInterval(() => { _this.checkLocalStorage() }, intervalCount)
			_this.getCurrentUserDetails()
		}
	},
	/**
	 * Run on `mounted` to initialize the app defaults.
	 * @function
	 * @returns {undefined}
	 * @memberof App
	 * @version 0.0.4
	 */
	mounted () {
		this.displayLoadingScreen = true

		// This will add all of the necessary classes to the body that aren't required outside of the app
		$('body').addClass('page-header-fixed').addClass('page-sidebar-closed-hide-logo').addClass('page-content-white').addClass('page-md').addClass('app-body')

		GlobalFunctions.init()
		GlobalFunctions.initApp()

		this.initEvents()
	},
	computed: mapGetters([
		'userAccountsLength',
		'selectedAccountId',
		'unoappAccount',
		'businessAccount',
		'locationAccount',
		'activeBusinessId',
		'activeBusinessName',
		'activeLocationId',
		'activeLocationName',
		'accessibleApps',
		'v3Token'
	]),
	methods: {
		/**
		 * To check if the session has been set in locolStorage and if it is expired.
		 * @function
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.4
		 */
		checkLocalStorage () {
			/* eslint-disable no-undef */
			const now = new Date().getTime()
			const sessionStart = localStorage.getItem('sessionStart')
			if (sessionStart == null) {
				localStorage.setItem('sessionStart', now)
			} else {
				if (now - sessionStart > timer) {
					this.showImStillHere()
				}
			}
		},
		/**
		 * To initialize event binding for checking inactivity.
		 * @function
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.4
		 */
		initEvents () {
			let _this = this

			// Throttling the event so that we don't need to run the function every time something is clicked or typed.
			let throttledEvent = throttle(() => { _this.imStillHere(true) }, throttleEventTimer, { 'trailing': false })
			$(window).on('click keyup', throttledEvent)
		},
		/**
		 * To set the name of the current route and sub route for selecting active navigation.
		 * @function
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.4
		 */
		setCurrentRoute () {
			if (this.$route) {
				let firstIndex = this.$route.path.indexOf('/', 1)
				let secondIndex = this.$route.path.indexOf('/', firstIndex + 1)

				if (secondIndex === -1) {
					secondIndex = this.$route.path.length
				}
				this.currentRoute = this.$route.path.substring(firstIndex + 1, secondIndex)

				if (secondIndex < this.$route.path.length - 1) {
					let thirdIndex = this.$route.path.indexOf('/', secondIndex + 1)
					if (thirdIndex === -1) {
						thirdIndex = this.$route.path.length
					}
					this.currentSubRoute = this.$route.path.substring(secondIndex + 1, thirdIndex)
				}
			}
		},
		/**
		 * To get the list of accounts that are associated to the current user.
		 * @function
		 * @param {boolean} confirmUser - A boolean that dictates whether the user still needs to be confirmed or not.
		 * @returns {object} - A promise that will either return an error message or perform an action.
		 * @memberof App
		 * @version 0.0.4
		 */
		getCurrentUserAccounts (confirmUser) {
			let _this = this

			if (this.selectedAccountId) {
				if (confirmUser) {
					this.$router.push('confirm_name')
				} else {
					this.waitingForData = false
				}
			} else {
				return Account.getUserAccounts().then(response => {
					_this.setActiveUserAccounts(response.payload.accounts)
					console.log('route params', _this.$route.params)

					if (confirmUser) {
						_this.$router.push('confirm_name')
					} else {
						_this.waitingForData = false
						// Get the user's accounts, show the modal if more than 1
						if (response.payload.accounts.length > 1) {
							_this.$router.push('select_account')
						} else if (response.payload.accounts.length === 1) {
							// Since this is the only account, just select the single account returned
							_this.loginToUserAccount(response.payload.accounts[0])
						}
					}
				}).catch(_this.$root.errorWrapper(e => {
					if (e.responseJSON) {
						$('body').removeClass('app-body')
						switch (e.responseJSON.declaration) {
						case 'no_accounts_found':
							_this.routeMessage = 'We were unable to find any accounts linked to your email. Please contact your admin.'
							_this.$router.message = _this.routeMessage
							_this.$router.push({path: '/error', props: {message: _this.routeMessage}})
							break

						default:
							// No default
						}
					}
				}))
			}
		},
		/**
		 * To login to the selected user account
		 * @function
		 * @param {object} account - The account that we are logging in to.
		 * @returns {object} - A promise that will either return an error message or perform an action.
		 * @memberof App
		 * @version 0.0.4
		 */
		loginToUserAccount (account) {
			let _this = this

			Auth.loginToAccount(account.account_id).then(response => {
				_this.setV3Token(response.payload.token)
				_this.getSelectedAccountDetails()
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					this.displayLoadingScreen = false
					$('body').removeClass('app-body')
					switch (e.responseJSON.declaration) {
					case 'invalid_account':
						_this.routeMessage = 'We were unable to find your account. Please contact the admin.'
						_this.$router.message = _this.routeMessage
						_this.$router.push({path: '/error', props: {message: _this.routeMessage}})
						break

					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To set the active business.
		 * @function
		 * @param {integer} business - The business id to be set as active.
		 * @param {boolean} fromLocalStorage - To determine if the business object is extracted from localStorage.
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.5
		 */
		setActiveBusiness (business, fromLocalStorage) {
			if (fromLocalStorage) {
				business = JSON.parse(business)
			}

			this.setActiveBusinessId(business.business_id)
			// update the local variable localBusinessId
			this.localBusinessId = this.activeBusinessId
			this.setActiveBusinessName(business.business_name)
			// store the business_id in localStorage
			localStorage.setItem('activeBusiness', JSON.stringify(business))
		},
		/**
		 * To set the active location.
		 * @function
		 * @param {integer} location - The location id to be set as active.
		 * @param {boolean} fromLocalStorage - To determine if the location object is extracted from localStorage.
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.9
		 */
		setActiveLocation (location, fromLocalStorage) {
			if (fromLocalStorage) {
				location = JSON.parse(location)
			}

			this.setActiveLocationId(location.location_id)
			this.setActiveLocationName(location.location_name)
			// store the location in localStorage
			localStorage.setItem('activeLocation', JSON.stringify(location))
		},
		/**
		 * To get the details of the selected user account and send/emit these details to the parent.
		 * @function
		 * @returns {object} - A promise that will either return an error message or perform an action.
		 * @memberof App
		 * @version 0.0.4
		 */
		getSelectedAccountDetails () {
			let _this = this

			Account.getCurrentAccountDetails().then(response => {
				_this.setActiveAccount(response.payload)
				if (_this.unoappAccount) {
					_this.setActiveBusiness(response.payload)
				} else {
					// Check localStorage for active business_id
					const activeBusiness = localStorage.getItem('activeBusiness')
					if (activeBusiness != null) {
						_this.setActiveBusiness(activeBusiness, true)
					} else {
						_this.setActiveBusinessName(response.payload.business_name)
					}
					// Check localStorage for active location
					const activeLocation = localStorage.getItem('activeLocation')
					if (activeLocation != null) {
						_this.setActiveLocation(activeLocation, true)
					} else {
						// Can't verify that this works yet as I don't have location users
						// _this.setActiveLocationId(response.payload.location_id)
						// _this.setActiveLocationName(response.payload.location_name)
					}
				}
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {
					case 'account_not_found':
						_this.routeMessage = 'We were unable to find the account you selected. Please contact the admin.'
						_this.$router.message = _this.routeMessage
						_this.$router.push({path: '/error', props: {message: _this.routeMessage}})
						break

					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To check if the user is currently logged into an account and to get the account details.
		 * @function
		 * @param {boolean} confirmUser - A boolean that dictates whether the user still needs to be confirmed or not.
		 * @returns {object} - A promise that will either return an error message or perform an action.
		 * @memberof App
		 * @version 0.0.4
		 */
		checkIfActiveUserAccount (confirmUser) {
			let _this = this
			return Account.getCurrentAccountDetails().then(response => {
				_this.setActiveAccount(response.payload)
				// Check localStorage for active business_id
				const activeBusiness = localStorage.getItem('activeBusiness')
				if (activeBusiness != null) {
					_this.setActiveBusiness(activeBusiness, true)
				} else {
					_this.setActiveBusinessId(response.payload.business_id)
					_this.setActiveBusinessName(response.payload.business_name)
				}
				// Check localStorage for active location
				const activeLocation = localStorage.getItem('activeLocation')
				if (activeLocation != null) {
					_this.setActiveLocation(activeLocation, true)
				} else {
					// Can't verify that this works yet as I don't have location users
					// _this.setActiveLocationId(response.payload.location_id)
					// _this.setActiveLocationName(response.payload.location_name)
				}
				_this.getCurrentUserAccounts(confirmUser)
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {
					case 'no_account_selected':
						_this.getCurrentUserAccounts(confirmUser)
						break

					case 'account_not_found':
						_this.routeMessage = 'We were unable to find the account you selected. Please contact the admin.'
						_this.$router.message = _this.routeMessage
						_this.$router.push({path: '/error', props: {message: _this.routeMessage}})
						break

					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To get the basic details of the current user and determine if any action needs to take place.
		 * @function
		 * @returns {object} - A promise that will either return an error message or perform an action.
		 * @memberof App
		 * @version 0.0.4
		 */
		getCurrentUserDetails () {
			let _this = this
			return User.getCurrentUserDetails().then(response => {
				_this.activeUser = response.payload
				this.setActiveUser(_this.activeUser)

				// Show a modal to confirm user's name on first login
				if (response.declaration === 'unconfirmed_user_name') {
					_this.waitingForData = false
					_this.checkIfActiveUserAccount(true)
				// Show a modal to select an account from a list of user's accounts
				} else if (response.declaration === 'user_found') {
					_this.checkIfActiveUserAccount()
				}
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					LoadingScreen.methods.removeLoadingScreen()
					$('body').removeClass('app-body')
					switch (e.responseJSON.declaration) {
					case 'user_not_found':
						_this.logOut(false, true)
						break

					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To display the modal to check if the user is still active.
		 * @function
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.4
		 */
		showImStillHere () {
			if (!this.displayImStillHere) {
				this.displayImStillHere = true

				if (localTimeout) {
					clearTimeout(localTimeout)
				}

				let _this = this

				localTimeout = setTimeout(() => { _this.logOut(1) }, timeoutCount)
			}
		},
		/**
		 * To close the modal and reinitiate the session since the user is still active.
		 * @function
		 * @param {boolean} userInteraction - Whether the event happened through user interaction or through clicking the button.
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.4
		 */
		imStillHere (userInteraction) {
			if (userInteraction && this.displayImStillHere) {
				// We can ignore this case because at this point we want them to click on the button
			} else {
				this.displayImStillHere = false

				if (localTimeout) {
					clearTimeout(localTimeout)
				}

				const now = new Date().getTime()
				localStorage.removeItem('sessionStart')
				localStorage.setItem('sessionStart', now)
			}
		},
		/**
		 * To toggle whether or not a submenu should be toggled open.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.4
		 */
		toggleNavigation (event) {
			let target = $(event.target).closest('.nav-item')
			if (!target.hasClass('active')) {
				// Active menus can't be closed
				if (target.hasClass('open')) {
					target.removeClass('open')
					target.find('.arrow').removeClass('open')
				} else {
					target.addClass('open')
					target.find('.arrow').addClass('open')
				}
			}
		},
		/**
		 * To toggle whether or not the sidebar should be toggled open.
		 * @function
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.4
		 */
		toggleQuickSidebar () {
			if (!this.locationAccount) {
				$('body').toggleClass('page-quick-sidebar-open')
			}
		},
		/**
		 * To toggle whether or not the sidebar navigation should be toggled open.
		 * @function
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.8
		 */
		toggleSidebarCollapse () {
			let body = $('body')
			let sidebarMenu = $('.page-sidebar-menu')

			if (body.hasClass('page-sidebar-closed')) {
				body.removeClass('page-sidebar-closed')
				sidebarMenu.removeClass('page-sidebar-menu-closed')
			} else {
				body.addClass('page-sidebar-closed')
				sidebarMenu.addClass('page-sidebar-menu-closed')
			}
		},
		/**
		 * To clear the current error.
		 * @function
		 * @param {string} type - The error message to be cleared.
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.5
		 */
		clearSearchError (type) {
			if (type === 'location') {
				this.locationSearchError = ''
			} else if (type === 'business') {
				this.businessSearchError = ''
			}
		},
		/**
		 * To get the list of locations for a business based on the search field.
		 * @function
		 * @param {object} location - The location object to be set as active/selected.
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.5
		 */
		getLocationSearchResults: debounce(function () {
			let _this = this

			if (_this.locationSearch.search.length >= 3) {
				Account.getLocationSearchResults().then(response => {
					_this.clearSearchError('location')
					_this.locationSearchResults = response.payload.locations
				}).catch(_this.$root.errorWrapper(e => {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
						case 'no_matching_locations_found':
							_this.locationSearchError = 'There are no matching records. Please try again.'
							break
						default:
							// No default
						}
					}
				}))
			} else {
				_this.locationSearchResults = []
			}
		}, 500),
		/**
		 * To log out of the current account and log into another one.
		 * @function
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.5
		 */
		changeAccount () {
			this.$router.push('select_account')
		},
		/**
		 * To log the user out of their current session.
		 * @function
		 * @param {boolean} userIdle - Whether the function was called on click or through user absence.
		 * @param {boolean} fatalError - Whether the function was called because of a fatal error or not.
		 * @returns {object} - A promise that will either return an error message or log the user out.
		 * @memberof App
		 * @version 0.0.4
		 */
		logOut (userIdle, fatalError) {
			if (userIdle) {
				const now = new Date().getTime()
				const sessionStart = localStorage.getItem('sessionStart')
				if (sessionStart != null) {
					if (now - sessionStart + timer < timeoutCount) {
						return
					}
				}
			}
			if (globalInterval) {
				clearInterval(globalInterval)
			}
			let _this = this
			return Auth.logOut(GlobalFunctions.convertBooleanToInt(userIdle)).then(response => {
				localStorage.removeItem('sessionStart')
				localStorage.removeItem('activeBusiness')
				localStorage.removeItem('activeLocation')
				if (fatalError) {
					_this.$router.push('/error')
				} else {
					_this.$router.push('/login')
				}
			}).catch(_this.$root.errorWrapper(e => {}))
		},
		...mapActions([
			'setActiveUser',
			'setActiveUserAccounts',
			'setActiveAccount',
			'setActiveBusinessId',
			'setActiveBusinessName',
			'setActiveLocationId',
			'setActiveLocationName',
			'setV3Token'
		])
	},
	watch: {
		/**
		 * Watch `$route` so that we can reset the current route on change.
		 * @function
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.4
		 */
		'$route' () {
			this.setCurrentRoute()
		},
		/**
		 * Watch `locationSearch.search` so that we can do a backend typeahead search.
		 * @function
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.5
		 */
		'locationSearch.search' () {
			this.getLocationSearchResults()
		},
		/**
		 * Watch `activeBusinessId` so that we can update the active business when this changes.
		 * @function
		 * @returns {undefined}
		 * @memberof App
		 * @version 0.0.5
		 */
		'activeBusinessId' () {
			if (this.activeBusinessId !== this.localBusinessId) {
				this.localBusinessId = this.activeBusinessId
			}
		}
	},
	components: {
		Modal,
		Dropdown,
		LoadingScreen,
		AppSidePanel
	}
}
</script>

<style>
	.app-bg {
		position: absolute;
	    width: 100%;
	    height: 100%;
	    background-color: #292E33;
	    z-index: 10000;
	}
	.page-header.navbar .page-logo .logo-default.logo-unoapp {
		width: auto;
		max-width: 125px;
		height: auto;
		display: block;
		margin: 9px 0px 0px;
	}
	.page-sidebar .page-sidebar-menu li.open>.sub-menu {
		display: block;
	}
	.center {
		text-align: center;
	}
	.form-body {
		margin-top: 20px;
	}
	body .swal2-container {
		z-index: 10050;
	}
	.swal2-modal .swal2-confirm:focus {
		outline: none;
	}
	.location-panel .logo-container {
		width: 48px;
		height: 100%;
		display: inline-block;
	}
	.location-panel .location-name-container {
		display: inline-block;
		margin-right: 8px;
	}
	.location-panel .logo-container .business-logo {
		height: 38px;
	    border-radius: 50%;
	    position: absolute;
	    top: 6px;
	    left: 0;
	    margin: 0px 8px;
	}
	.location-panel .location-name-container .business-name, .location-panel .location-name-container .business-location-name {
		color: #c6cfda;
		width: auto;
		max-width: 155px;
		display: block;
	    font-size: 11px;
	    font-weight: 300;
	    word-break: break-word;
	    text-overflow: ellipsis;
	    white-space: nowrap;
	    overflow: hidden;
	}
	.location-panel .location-name-container .business-name.big {
		font-size: 13px;
		line-height: 41px;
	}
	.location-panel .location-name-container .business-location-name {
		font-size: 13px;
	}
	.page-quick-sidebar {
		margin-top: 50px;
	}
	.page-quick-sidebar-wrapper .page-quick-sidebar .page-quick-sidebar-chat .page-quick-sidebar-chat-users .media-list .media.selected-location {
		background-color: rgba(55, 183, 217, .3);
	}
	.page-quick-sidebar-wrapper .page-quick-sidebar .page-quick-sidebar-chat .page-quick-sidebar-chat-users .media-list .media.selected-location:hover {
		background-color: rgba(55, 183, 217, .5);
	}
	.page-quick-sidebar-wrapper .page-quick-sidebar .list-heading.location-panel-heading {
		color: rgba(55, 183, 217, .5);
		font-size: 18px;
		text-transform: uppercase;
	}
	.page-header .top-menu .dropdown-quick-sidebar-toggler>.dropdown-toggle.location-panel {
		padding: 5px 0px!important;
		height: 50px;
		width: 120px;
	}
	.page-header .top-menu .dropdown-quick-sidebar-toggler>.dropdown-toggle.location-panel.width-auto {
		width: auto;
		max-width: 220px;
	}
	.page-quick-sidebar-wrapper .page-quick-sidebar-toggler {
		position: absolute;
	}
	.page-quick-sidebar-open .page-quick-sidebar-toggler > span {
		color: #99a8b5;
		font-size: 20px;
	}
	.page-quick-sidebar-toggler > span:hover {
	    color: #fff!important;
	}
	a.panel-link {
		color: #99a8b5;
		text-decoration: underline;
	}
	a.panel-link:hover {
		color: #fff!important;
	}
	.scrollable {
		height: calc(100vh - 295px);
	    overflow-y: auto;
	    overflow-x: hidden;
	}
	div.tab-pane::-webkit-scrollbar {
		background-color: transparent;
		width: 7px;
	}
	div.tab-pane::-webkit-scrollbar-thumb {
		background-color: #99a8b5;
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
	}
	div.tab-pane::-webkit-scrollbar-track {
	    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	    border-radius: 10px;
	}
	.col-sm-3.no-padding, .col-sm-8.no-padding {
		padding: 0;
		margin-left: 5px;
	}
	.page-quick-sidebar-wrapper .page-quick-sidebar .page-quick-sidebar-chat .page-quick-sidebar-chat-users.active-business {
		padding-top: 0px;
	}
	.page-quick-sidebar-wrapper .page-quick-sidebar .page-quick-sidebar-chat .page-quick-sidebar-chat-users .media-list .media .media-body .media-heading-sub {
		margin-top: 5px;
	}
	.padding-box {
		padding: 10px;
	}
	#location_search {
		color: #99a8b5;
	}
	.blue {
		color: rgba(55, 183, 217, .5);
	}
	.form-group.form-md-line-input .form-control.input-sm.padding-right-20 {
		padding-right: 20px;
	}
	.clear-icon {
		position: absolute;
	    right: 0;
	    top: 30px;
	    color: #32c5d2;
	    cursor: pointer;
	}
	.page-header.navbar .top-menu .navbar-nav>li.dropdown.width-auto {
		width: auto;
		max-width: 220px;
	}
	.page-quick-sidebar-open .page-quick-sidebar-wrapper {
		z-index: 10049;
	}
	.form-group .el-date-editor.el-input {
		width: 100%;
	}
	.el-date-editor.el-input > input {
		font-size: 14px;
	    padding: 6px 0;
	    background: 0 0;
	    border: 0;
	    border-bottom: 2px solid #64c3d0;
	    -webkit-border-radius: 0;
	    -moz-border-radius: 0;
	    -ms-border-radius: 0;
	    -o-border-radius: 0;
	    border-radius: 0;
	    color: #555;
	    box-shadow: none;
	    width: 100%;
	}
	.form-group.form-md-line-input.no-top-padding {
		padding-top: 0;
	}
	.el-picker-panel {
		max-width: 265px;
	}
	.el-time-panel {
		max-width: 200px;
	}
	.search-table.table-responsive {
		overflow: inherit;
	}
	.page-fixed-height {
		height: calc(100vh - 50px);
    	margin-bottom: -20px;
    	margin-top: -20px;
		padding-top: 20px;
    	overflow: hidden;
	}

	/* Allow portlets inside short sideways-* divs to scroll */
	.portlet {
		overflow: auto;
	}
</style>



// WEBPACK FOOTER //
// App.vue?b30741ea